import { SET_MOBILE_SIDEBAR_VIEW } from '../actions';
import { VIEWS } from '../constants';

export default (state, action) => {
  if (!state) {
    return {
      currentView: VIEWS.ROOT,
    };
  }

  switch (action.type) {
    case SET_MOBILE_SIDEBAR_VIEW:
      return {
        ...state,
        currentView: action.currentView,
      };

    // Reset the sidebar view to root level when a user logs in
    case 'USER_RECEIVE':
      return {
        ...state,
        currentView: VIEWS.ROOT,
      };

    default:
      break;
  }

  return state;
};
